// Tab validation utility
export const validateTab = (tab) => {
  const errors = [];
  
  if (!tab) {
    return { isValid: false, errors: ['Tab data is missing'] };
  }
  
  if (typeof tab !== 'object') {
    return { isValid: false, errors: ['Tab must be an object'] };
  }
  
  // Validate required fields
  if (!tab.id) {
    errors.push('Tab is missing required "id" field');
  }
  
  if (!tab.name) {
    errors.push('Tab is missing required "name" field');
  }
  
  // Validate card_list if present
  if (tab.card_list) {
    if (!Array.isArray(tab.card_list)) {
      errors.push('Tab card_list must be an array');
    }
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Schema/Page validation utility
export const validateSchema = (schema) => {
  const errors = [];
  
  if (!schema) {
    return { isValid: false, errors: ['Schema data is missing'] };
  }
  
  if (typeof schema !== 'object') {
    return { isValid: false, errors: ['Schema must be an object'] };
  }
  
  // Validate tabs if present
  if (schema.tabs) {
    if (!Array.isArray(schema.tabs)) {
      errors.push('Schema tabs must be an array');
    }
  }
  
  // Validate card_list if present
  if (schema.card_list) {
    if (!Array.isArray(schema.card_list)) {
      errors.push('Schema card_list must be an array');
    }
  }
  
  // Validate cards_layout if present
  if (schema.cards_layout) {
    if (typeof schema.cards_layout !== 'object') {
      errors.push('Schema cards_layout must be an object');
    } else {
      const validLayouts = ['row', 'column', 'grid'];
      if (schema.cards_layout.layout && !validLayouts.includes(schema.cards_layout.layout)) {
        errors.push(`Invalid cards_layout.layout: ${schema.cards_layout.layout}. Must be one of: ${validLayouts.join(', ')}`);
      }
      
      if (schema.cards_layout.columns && typeof schema.cards_layout.columns !== 'number') {
        errors.push('cards_layout.columns must be a number');
      }
    }
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}; 